import React, { FunctionComponent, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Alert from '@justgiving/alert';
import { removeGlobalAlert } from './GlobalAlert.actions';

const GlobalAlert: FunctionComponent = () => {
  const message = useSelector((state: State) => state.globalAlert);
  const dispatch = useDispatch();

  useEffect(() => {
    if (message !== null) window.scrollTo(0, 0);
  }, [message]);

  if (!message) return null;

  return (
    <Alert type="success" onClose={() => dispatch(removeGlobalAlert())}>
      {message}
    </Alert>
  );
};

export default GlobalAlert;
